import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js"
import SolidGauge from "highcharts/modules/solid-gauge.js";
import ReactHighcharts from 'highcharts-react-official';
import { toDisplayTimeString } from '../../../helpers/moment-ex';
import LoadingStyle from '../Common/LoadingStyle';

HighchartsMore(Highcharts);
SolidGauge(Highcharts);

const DonutView = (props) => {
  const crewInfo = useSelector(state => state.dashboard.crew.analyseById.hasOwnProperty(props.crewId) ? state.dashboard.crew.analyseById[props.crewId] : {});
  const donut = crewInfo.donut;
  const isRequestingKpi = crewInfo.elasticWork ? crewInfo.elasticWork.isRequesting : false;
  let chartRef = null;

  useEffect(() => {
    chartRef = React.createRef();
  }, []);

  const colors = {
    titleColor: '#002653',
    backgroundColor: '#ffffff',
    primaryColor: '#ececec',
    secondaryColor: '#087afc'
  };

  const [options, setOptions] = useState({
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    chart: {
      type: 'solidgauge',
      height: '100%',
      backgroundColor: colors.backgroundColor,
    },
    title: {
      text: '<div><p style="font-size:1.5em; font-weight: bold;margin-bottom: 0.2rem; ">0%</p>' +
        '<span>Utilization</span>',
      verticalAlign: 'middle',
      floating: true,
      useHTML: Boolean,
      style: {
        "color": colors.titleColor,
        "fontSize": "0.7em",
        "text-align": "center"
      },
      y: 10
    },
    tooltip: {
      enabled: false
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [{
        outerRadius: '102%',
        innerRadius: '103%',
        backgroundColor: colors.secondaryColor,
        borderWidth: 0
      }, {
        outerRadius: '67%',
        innerRadius: '69%',
        backgroundColor: colors.primaryColor,
        borderWidth: 0
      }]
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: []
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true
      }
    },
    series: []
  });

  useEffect(() => {
    if (!donut) return;

    let titleText = null;
    if (donut.payload.hasOwnProperty('utilization')) {
      titleText = `<div><p style="font-size:1.5em; font-weight: bold;margin-bottom: 0.2rem; ">${Math.round(donut.payload.utilization)}%</p>` +
        `<span>Utilization</span>`;
    }

    let series = [];
    if (donut.payload.hasOwnProperty('planned_work_percentage') && donut.payload.planned_work_percentage > 0) {
      series.push({
        name: 'Planned Work',
        borderWidth: 2,
        borderColor: colors.secondaryColor,
        data: [{
          color: colors.backgroundColor,
          radius: '109%',
          innerRadius: '95%',
          y: donut.payload.planned_work_percentage === Infinity ? 100 : donut.payload.planned_work_percentage
        }]
      });
    }

    if (donut.payload.hasOwnProperty('planned_utilization_percentage') && donut.payload.planned_utilization_percentage > 0) {
      series.push({
        name: 'Planned Utilization',
        data: [{
          color: colors.secondaryColor,
          radius: '109%',
          innerRadius: '95%',
          y: donut.payload.planned_utilization_percentage === Infinity ? 100 : donut.payload.planned_utilization_percentage
        }]
      });
    }

    if (donut.payload.hasOwnProperty('actual_work_percentage') && donut.payload.actual_work_percentage > 0) {
      series.push({
        name: 'Actual Work',
        borderWidth: 3,
        borderColor: colors.primaryColor,
        data: [{
          color: colors.backgroundColor,
          radius: '74%',
          innerRadius: '60%',
          y: donut.payload.actual_work_percentage === Infinity ? 100 : donut.payload.actual_work_percentage
        }]
      });
    }

    if (donut.payload.hasOwnProperty('actual_utilization_percentage') && donut.payload.actual_utilization_percentage > 0) {
      series.push({
        name: 'Actual Utilization',
        data: [{
          color: colors.primaryColor,
          radius: '74%',
          innerRadius: '60%',
          y: donut.payload.actual_utilization_percentage === Infinity ? 100 : donut.payload.actual_utilization_percentage
        }]
      });
    }

    setOptions({
      ...options,
      ...titleText && {
        title: {
          ...options.title,
          text: titleText
        }
      },
      series
    })
  }, [donut]);

  const isRequesting = donut ? donut.isRequesting : false;

  return <>
    <Row className="donut-view">
      <ReactHighcharts highcharts={Highcharts} options={options} ref={chartRef}></ReactHighcharts>
    </Row>
    <Row className="body-footer">
      <Col className="p-0">
        <div className="value">{isRequesting
          ? <LoadingStyle />
          : <>{(donut && donut.payload) ? toDisplayTimeString(donut.payload.planned_utilization) : 0} /
            <span>{(donut && donut.payload) ? toDisplayTimeString(donut.payload.planned_work) : 0}</span></>}
        </div>
        <div className="label">Planned</div>
      </Col>
      <Col lg={1} md={1} sm={1}><div className="splitter" /></Col>
      <Col className="p-0">
        <div className="value">{(isRequesting || isRequestingKpi)
          ? <LoadingStyle />
          : <>{(donut && donut.payload) ? toDisplayTimeString(donut.payload.actual_utilization) : 0} /
            <span>{(donut && donut.payload) ? toDisplayTimeString(donut.payload.actual_work) : 0}</span></>}
        </div>
        <div className="label">Actual</div>
      </Col>
    </Row>
  </>
}

export default DonutView;
